import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { colors, IconButton } from '@sweep-io/sweep-design';
import { Close } from '@sweep-io/sweep-design/dist/icons/Close';

interface SearchFullViewLayoutProps {
  isExpandedMode: boolean;
  searchInput: ReactNode;
  onClose?: () => void;
  children: ReactNode;
}

export const SearchFullViewLayout = ({
  isExpandedMode,
  searchInput,
  onClose,
  children,
}: SearchFullViewLayoutProps) => (
  <Stack
    height="100%"
    ml={isExpandedMode ? '32px' : '0'}
    mr={isExpandedMode ? '32px' : '0'}
    border={isExpandedMode ? '1px solid' : 'none'}
    borderColor={isExpandedMode ? colors.grey[300] : 'transparent'}
    borderRadius={isExpandedMode ? '12px 12px 0 0' : '0'}
  >
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '56px',
        backgroundColor: isExpandedMode ? colors.grey[100] : 'transparent',
        borderRadius: isExpandedMode ? '12px 12px 0 0' : '0',
        pr: isExpandedMode ? 1.5 : 0,
      }}
    >
      <Box sx={{ pl: isExpandedMode ? 1 : 0, width: '100%' }}>{searchInput}</Box>
      {onClose && (
        <>
          <Box sx={{ flex: 1 }} />
          <IconButton variant="flat" size="small" onClick={onClose}>
            <Close />
          </IconButton>
        </>
      )}
    </Box>

    <Box sx={{ flex: 1, overflow: 'hidden' }}>{children}</Box>
  </Stack>
);
